import Modal from '@/components/Modal/Modal';
import useModalState from '@/hooks/pure/useModalState';
import useFeedbackSourceStore from '@/stores/Feedback/FeedbackSourceStore';
import useLocaleStore from '@/stores/LocaleStore';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { SOURCE_TYPE } from '@/types/feedbackConst';

import { ProviderContainer } from '../../components/ProviderContainer';
import type { IntegrationItemProps } from '../../types';
import type { AppleAppStoreInfo } from '../types';
import AppleAppStoreConnectModal from './AppleAppStoreConnectModal';
import { useAppleAppStore } from './useAppleAppStore';

export const AppleAppStoreItem = (props: IntegrationItemProps) => {
  const { isConnector } = props;
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const fetchFeedbackSources = useFeedbackSourceStore(
    (state) => state.fetchFeedbackSources,
  );
  const regionMap = useLocaleStore((state) => state.regionMap);

  const { appleAppStoreInfo, disconnectAppleAppStoreMutation, refetch } =
    useAppleAppStore(!isConnector);

  const connectModalState = useModalState();

  const handleConnectComplete = async () => {
    if (!currWorkspace) return;
    await connectModalState.close();
    await fetchFeedbackSources(currWorkspace.alias);
    await refetch();
  };

  const handleDisconnect = (info: AppleAppStoreInfo) => {
    disconnectAppleAppStoreMutation({ app_id: info.alias });
  };

  return (
    <>
      <ProviderContainer
        multiInfoEnabled={true}
        connected={!!appleAppStoreInfo && appleAppStoreInfo.length > 0}
        source={SOURCE_TYPE.APPLE_APP_STORE}
        description="Import reviews as feedbacks into Syncly."
        onAddInfoClick={() => connectModalState.open()}
        connectedDisplay={(info) => {
          const country =
            regionMap[info.app_info.country.toUpperCase()]?.country;
          const name = info.app_info.title;
          return `${name} | ${country}`;
        }}
        infos={appleAppStoreInfo || []}
        onDisconnect={handleDisconnect}
        onConnectClick={() => connectModalState.open()}
      />
      <Modal
        status={connectModalState.status}
        closeModal={connectModalState.close}
      >
        <AppleAppStoreConnectModal onConnectComplete={handleConnectComplete} />
      </Modal>
    </>
  );
};
